import { GetTenantByCodeDocument } from '@graphql/generated/graphql';

import { APIService } from '@services/ApiService';
import { AuthService } from '@services/AuthService/AuthService';

import { useLazyQuery } from '@apollo/client';

export const useFindCompanyByCode = () => {
    return useLazyQuery(GetTenantByCodeDocument, {
        context: {
            globalUrl: true,
        },
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true,
        onCompleted: ({ tenant }) => {
            AuthService.setTenantUuid(tenant.uuid);
            new APIService().setGraphAPI = tenant.apiUrl;
        },
    });
};
